<template>
  <div>
    <XVactionbar v-if="settings.showDossierSubmitButtons === 1 || settings.showBackButton === 1">
      <template slot="actionbuttons">
        <!-- huidige pagina btnShowChangeTArgetPeriodScreen nu in: If Not Page.IsPostBack Then -->
        <button
          type="button"
          id="btnTerug"
          class="btn btn-primary btn-xs"
          @click.prevent="btnTerug"
          v-if="settings.showBackButton === 1"
        >
          <font-awesome-icon icon="chevron-left" />
          {{ translation(14449) }}
        </button>
        <button
          type="button"
          id="btnDossierSubmit"
          class="btn btn-primary btn-xs"
          @click.prevent="btnDossierSubmit"
          v-if="settings.showDossierSubmitButtons === 1 && targetGegevens.wizardDossierLink !== null"
        >
          <span v-html="translation(targetGegevens.wizardDossierLinkTextID)"></span>
        </button>
        <button
          type="button"
          id="btnspE060Link"
          class="btn btn-primary btn-xs"
          @click.prevent="btnspE060Link"
          v-if="settings.showDossierSubmitButtons === 1 && targetGegevens.spE060Link !== null"
        >
          <span v-html="translation(targetGegevens.spE060LinkTextID)"></span>
        </button>
      </template>
    </XVactionbar>
    <div v-if="statusTargetberekening === 1">
      <XVwaiter :text="translation(15206)"></XVwaiter>
    </div>
    <div v-if="statusTargetberekening === 0">
      <XVSticky>
        <div class="stickybar" id="spe026stickybar">
          <div class="stickybartext">
            <span v-if="targetGegevens.targetGroupName !== null" v-html="targetGegevens.targetGroupName">
              <font-awesome-icon icon="chevron-right" />
            </span>
            <span v-if="targetGegevens.targetname !== null" v-html="targetGegevens.targetname"></span>
          </div>
        </div>
      </XVSticky>
      <div class="row" v-if="settings.showTitle === 1 || graphdata.length === 0">
        <div class="col-md-12">
          <span id="lblTitel" class="titel" v-html="settings.lblTitle" v-if="settings.showTitle === 1"></span>
          <font-awesome-icon
            :icon="['far', 'print']"
            class="pull-right fa-2x pointer"
            @click="printpage"
            v-if="graphdata.length === 0"
          />
        </div>
      </div>
      <div class="row margin20bottom" v-if="graphdata.length > 0">
        <div class="col-md-12">
          <XVgraphcontrol :graphdata="graphdata" @graphClick="graphClick"></XVgraphcontrol>
        </div>
      </div>
      <div class="row" v-if="settings.showSubTitle === 1">
        <div class="col-md-12">
          <span id="lblSubTitle" v-html="settings.lblSubTitle"></span>
        </div>
      </div>
      <div class="row lblinfo" v-if="targetGegevens.targetDesc !== null">
        <div class="col-md-12">
          <XVreadmore :text="targetGegevens.targetDesc" link="#" :max-chars="400"></XVreadmore>
        </div>
      </div>
      <div class="row" v-if="targetGegevens.tempPersonProfGroupTargetCalcShortageOptionalPriorPeriods > 0">
        <div class="col-md-12">
          <span v-html="translation(656)"></span>
          <span v-html="txtCalcShortageOptionalPriorPeriods"></span>
        </div>
      </div>
      <div class="row" v-if="targetGegevens.tempPersonProfGroupTargetCalcShortageOptionalEliminatedPriorPeriods > 0">
        <div class="col-md-12">
          <span v-html="'(' + txtCalcShortageOptionalEliminatedPriorPeriods + ' ' + translation(657) + ')'"></span>
        </div>
      </div>
      <fieldset class="margin20">
        <XVbootstraprow
          id="spe026periode"
          class="margin20"
          :label="translation(198)"
          :helptext="translation(1029)"
          v-if="targetGegevens.trPeriode_Visible === 1"
        >
          <span v-html="targetGegevens.lblPeriode"></span>
        </XVbootstraprow>
        <XVbootstraprow
          id="spe026status"
          :label="translation(13798)"
          :helptext="translation(18849)"
          v-if="targetGegevens.trStatus_Visible === 1 && targetGegevens.trProgressbar_Visible === 0"
        >
          <span v-html="targetGegevens.lblStatus"></span>
        </XVbootstraprow>
        <XVbootstraprow id="spe026status" :label="translation(13798)" v-if="targetGegevens.trProgressbar_Visible === 1">
          <XVprogressbar
            v-bind="{
              nettoTarget: targetGegevens.lblScore,
              normTarget: targetGegevens.lblNorm,
              progressTarget: targetGegevens.progressTarget,
              targetCalcResult: targetGegevens.tempPersonProfGroupTargetCalcResult,
              statustextTarget: targetGegevens.lblStatus,
              settingprogbar: targetGegevens.codeProgressbar,
            }"
          ></XVprogressbar>
        </XVbootstraprow>
        <XVbootstraprow
          id="spe026norm"
          :label="translation(631)"
          :helptext="translation(1030)"
          v-if="targetGegevens.trNorm_Visible === 1"
        >
          <span v-html="txtNorm"></span>
        </XVbootstraprow>
        <!-- tekort vorige periode -->
        <XVbootstraprow
          id="spe026tekort"
          label=" "
          :helptext="translation(15403)"
          v-if="targetGegevens.tempPersonProfGroupTargetCalcShortageMandatoryPriorPeriods > 0"
        >
          <label v-html="translation(15402) + ': '"></label>
          <span v-html="txtCalcShortageMandatoryPriorPeriods"></span>
        </XVbootstraprow>
        <!-- optioneel tekort vorige periode  -->
        <XVbootstraprow
          id="spe026optekort"
          label=" "
          :helptext="translation(15405)"
          v-if="targetGegevens.tempPersonProfGroupTargetCalcShortageOptionalPriorPeriods > 0"
        >
          <label v-html="translation(15404) + ': '"></label>
          <span v-html="txtCalcShortageOptionalPriorPeriod"></span>
        </XVbootstraprow>
        <XVbootstraprow id="spe026motivation" label=" " v-if="targetGegevens.mutationAllowMotivation">
          <span v-html="targetGegevens.mutationAllowMotivation"></span>
        </XVbootstraprow>
        <!-- score -->
        <XVbootstraprow
          id="spe026score"
          :label="translation(635)"
          :helptext="translation(1031)"
          v-if="targetGegevens.trScore_Visible === 1"
        >
          <span v-html="txtScore"></span>
        </XVbootstraprow>
        <!-- overschot -->
        <XVbootstraprow
          id="spe026overschot"
          label=" "
          :helptext="translation(15407)"
          v-if="targetGegevens.tempPersonProfGroupTargetCalcRemainsUsedPriorPeriods > 0"
        >
          <span v-html="'+ ' + translation(16008) + ' : '"></span>
          <span v-html="txtOverschotpunten"></span>
        </XVbootstraprow>
        <XVbootstraprow
          id="spe026overschotover"
          label=" "
          v-if="
            this.targetGegevens.tempPersonProfGroupTargetCalcRemainsAvailablePriorPeriods -
              this.targetGegevens.tempPersonProfGroupTargetCalcRemainsUsedPriorPeriods >
            0
          "
        >
          <span v-html="translation(16009) + ': ' + txtOverschotpuntenover"></span>
        </XVbootstraprow>
        <XVbootstraprow
          id="spe026validatedpoints"
          :label="translation(3908)"
          :helptext="translation(3900)"
          v-if="targetGegevens.trValidatedPoints_Visible === 1"
        >
          <span v-html="txtValidatedPoints"></span>
        </XVbootstraprow>
        <div id="spe026compchart" class="row margin20bottom" v-if="settings.showCompChart === 1">
          <div class="col-md-4">
            <label class="pointer" @click="spanShowCompChart" v-if="pagesettings.compchartvisible === false">{{
              translation(4578) + ' '
            }}</label>
            <label class="pointer" @click="spanHideCompChart" v-if="pagesettings.compchartvisible === true">{{
              translation(4578) + ' '
            }}</label>
            <font-awesome-icon
              icon="chevron-down"
              class="pointer"
              @click="spanShowCompChart"
              v-if="pagesettings.compchartvisible === false"
            />
            <font-awesome-icon
              icon="chevron-up"
              class="pointer"
              @click="spanHideCompChart"
              v-if="pagesettings.compchartvisible === true"
            />
            <XVhelpcontrol :helptext="translation(4579)" class="pull-right"></XVhelpcontrol>
          </div>
        </div>
        <div
          id="spe026compchartcontent"
          class="row"
          v-if="settings.showCompChart === 1 && pagesettings.compchartvisible === true"
        >
          <div class="col-md-12">
            <xvbalkgrafiek
              :data="dataGrafiek"
              :options="optionsGrafiek"
              v-if="pagesettings.compchartvisible === true && competenceGraphdata !== []"
            ></xvbalkgrafiek>
          </div>
        </div>
        <div
          id="spe026comppoints"
          class="row"
          v-if="settings.showCompChart === 1 && pagesettings.compchartvisible === true"
        >
          <div class="col-md-12">
            <span v-html="translation(4580) + ' ' + txtcomppunten + ' ' + translation(4581)"></span>
          </div>
        </div>
        <div
          id="spe026compTable"
          class="row margin20 margin20bottom"
          v-if="settings.showCompChart === 1 && pagesettings.compchartvisible === true"
        >
          <div class="col-md-12">
            <label @click="spanShowCompTable" class="pointer" v-if="pagesettings.comptablevisible === false"
              >{{ translation(15431) }} &nbsp;</label
            >
            <font-awesome-icon
              icon="chevron-down"
              class="pointer"
              @click="spanShowCompTable"
              v-if="pagesettings.comptablevisible === false"
            />

            <label @click="spanHideCompTable" class="pointer" v-if="pagesettings.comptablevisible === true"
              >{{ translation(15432) }}&nbsp;</label
            >
            <font-awesome-icon
              icon="chevron-up"
              class="pointer"
              @click="spanHideCompTable"
              v-if="pagesettings.comptablevisible === true"
            />
            <XVtableV2
              v-if="pagesettings.compchartvisible === true && pagesettings.comptablevisible === true"
              :filterfunc="compFilterfunc"
              :tablesetting="competenceTable.tablesetting"
              :tablecolumnsetting="competenceTable.tablecolumnsetting"
              :tabledata="competenceTable.tabledata"
              :rowvisible="competenceTable.rowvisible"
              :XVtableSetRowStateProperty="compXVtableSetRowStateProperty"
              :paging="true"
            >
              <template slot="compPoints" slot-scope="dr">
                <span v-if="dr.row.compPoints">{{ Number(dr.row.compPoints) }}</span>
              </template>
              <template slot="compPoints_detailrow" slot-scope="dr">
                <div class="row">
                  <div class="col-md-4 col-sm-4 col-xs-12">
                    <label>{{ translation(4582) }}</label>
                  </div>
                  <div class="col-md-8 col-sm-8 col-xs-12 form-group">
                    <span v-if="dr.row.compPoints">{{ Number(dr.row.compPoints) }}</span>
                  </div>
                </div>
              </template>
            </XVtableV2>
          </div>
        </div>
      </fieldset>
      <br />
      <div class="flex-container">
        <div class="subtarget-item subtarget-mainheader">
          <div class="targetbox-content">
            <font-awesome-icon
              @click="showAllSubrules"
              icon="chevron-double-down"
              class="pointer"
              v-if="!subruleOpen"
            />
            <font-awesome-icon @click="hideAllSubrules" icon="chevron-double-up" class="pointer" v-if="subruleOpen" />
            <span v-html="translation(15390)"></span>
            <!-- <span class="pull-right" v-html="translation(15391) + '/' + translation(15392)"></span> -->
          </div>
        </div>
        <XVtargetsubregels
          v-for="(subrule, index) in subrules"
          :key="index"
          v-bind="subrule"
          :subrulebuttons="subrulebuttons(subrule.tblProfGroupSubRuleID)"
          :subruleloaded="subruleloaded(subrule.tblProfGroupSubRuleID)"
          :XVTablesort="XVTablesort"
          :XVtableSetRowStateProperty="XVtableSetRowStateProperty"
          :XVtablecolumnsettingchanged="XVtablecolumnsettingchanged"
          :targetTable="targetTable"
          :targetTableColumns="targetTableColumns"
          :getXVtable="getXVtable"
          :setsession="setsession"
          :trafficlightplacement="trafficlightplacement"
        ></XVtargetsubregels>
      </div>
    </div>
  </div>
</template>

<script>
'use strict'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { FAMixin, util } from 'pevueglobal'
import { sync } from 'vuex-pathify'

export default {
  mixins: [FAMixin],
  data: function () {
    return {}
  },
  async mounted() {
    this.resetCompetence()
    this.getTexten()
    let xtargetID
    let xautonumID
    let xlasttarget

    if (this.$route.params.lasttarget) {
      xtargetID = null
      xautonumID = null
      xlasttarget = parseInt(this.$route.params.lasttarget, 10)
    }
    if (this.$route.params.autonumID) {
      xtargetID = null
      xautonumID = this.$route.params.autonumID
      xlasttarget = 0
    }
    if (this.$route.params.targetID) {
      xtargetID = this.$route.params.targetID
      xautonumID = null
      xlasttarget = 0
    }
    let parsedshowtitle = parseInt(this.$route.params.showtitle)
    let parsedshowbackbtn = parseInt(this.$route.params.showbackbtn)
    this.setinputdata({
      targetID: xtargetID,
      autoNumID: xautonumID,
      lastTarget: !!xlasttarget,
      showTitle: !!parsedshowtitle,
      showBackButton: !!parsedshowbackbtn,
    })
    await this.getTargetsdetails()
    this.stopLoading()
  },
  computed: {
    ...mapGetters('Spe026PrDetailPE', [
      'statusTargetberekening',
      'settings',
      'targetGegevens',
      'subrules',
      'subrulebuttons',
      'subruleloaded',
      'targetTable',
      'targetTableColumns',
      'subruleOpen',
      'competenceTable',
      'competenceGraphdata',
      'competenceloaded',
      'graphdata',
    ]),
    pagesettings: sync('Spe026PrDetailPE/pagesettings'),
    inputdata: sync('Spe026PrDetailPE/inputdata'),
    txtCalcShortageMandatoryPriorPeriods() {
      return util.format2decimal(this.targetGegevens.tempPersonProfGroupTargetCalcShortageMandatoryPriorPeriods)
    },
    txtCalcShortageOptionalPriorPeriods() {
      return util.format2decimal(this.targetGegevens.tempPersonProfGroupTargetCalcShortageOptionalPriorPeriods)
    },
    txtCalcShortageOptionalEliminatedPriorPeriods() {
      return util.format2decimal(
        this.targetGegevens.tempPersonProfGroupTargetCalcShortageOptionalEliminatedPriorPeriods
      )
    },
    txtOverschotpunten() {
      let endscore =
        this.targetGegevens.lblScore + this.targetGegevens.tempPersonProfGroupTargetCalcRemainsUsedPriorPeriods
      return (
        util.format2decimal(this.targetGegevens.tempPersonProfGroupTargetCalcRemainsUsedPriorPeriods) +
        ' = ' +
        util.format2decimal(endscore)
      )
    },
    txtOverschotpuntenover() {
      let somoverschot =
        this.targetGegevens.tempPersonProfGroupTargetCalcRemainsAvailablePriorPeriods -
        this.targetGegevens.tempPersonProfGroupTargetCalcRemainsUsedPriorPeriods
      somoverschot = util.format2decimal(somoverschot)
      return somoverschot
    },
    txtScore() {
      return util.format2decimal(this.targetGegevens.lblScore)
    },
    txtValidatedPoints() {
      return util.format2decimal(this.targetGegevens.lblValidatedPoints)
    },
    txtNorm() {
      return util.format2decimal(this.targetGegevens.lblNorm)
    },
    txtcomppunten() {
      return util.format2decimal(this.competenceGraphdata.compPoints)
    },
    dataGrafiek: function () {
      return {
        labels: this.competenceGraphdata.graphlabels,
        datasets: [
          {
            barPercentage: 0.8,
            label: 'Data One',
            backgroundColor: this.competenceGraphdata.graphkleuren,
            data: this.competenceGraphdata.graphwaarden,
          },
        ],
      }
    },
    optionsGrafiek: function () {
      return {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                color: 'rgba(0, 0, 0, 0)',
                offsetGridLines: false,
                zeroLineColor: 'transparent',
                drawBorder: false,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                max: 100,
                min: 0,
                callback: function (value, index, values) {
                  return value + '%'
                },
              },
              gridLines: {
                color: 'rgba(238, 238, 238, 1)',
                zeroLineColor: 'rgba(238, 238, 238, 1)',
                offsetGridLines: false,
                drawBorder: false,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        tooltips: {
          callbacks: {
            label: (tooltipItems, data) => {
              // return tooltipItems.xLabel.toLocaleString(PEGLOBALS.Xculture)
              return util.format2decimal(tooltipItems.xLabel)
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
      }
    },
    trafficlightplacement() {
      let progressbarAanwezig = this.subrules.filter(
        (d) =>
          d.tblProfGroupSubruleCodeShowSubruleOverviewCols === 1 ||
          d.tblProfGroupSubruleCodeShowSubruleOverviewCols === 3 ||
          d.tblProfGroupSubruleCodeShowSubruleOverviewCols === 5 ||
          d.tblProfGroupSubruleCodeShowSubruleOverviewCols === 6
      )
      if (progressbarAanwezig.length === 0) {
        return false
      } else {
        return true
      }
    },
  },
  methods: {
    ...mapActions('Spe026PrDetailPE', ['getTargetsdetails', 'getXVtable', 'getcompetence', 'getGraphUrl', 'getTexten']),
    ...mapMutations('Spe026PrDetailPE', [
      'setpagesettings',
      'setinputdata',
      'toggleSubruleVisible',
      'XVTablesort',
      'XVtableSetRowStateProperty',
      'XVtablecolumnsettingchanged',
      'compXVtableSetRowStateProperty',
      'compInitXVtableState',
      'setsession',
      'resetCompetence',
      'resetData',
    ]),
    graphClick: function (graphClickinfo) {
      const graphGetUrlinputApi = {
        pagename: 'SPE026_PR_DetailPE.aspx',
        clientid: '',
        filters: [
          {
            key: 'personid',
            intvalue: this.targetGegevens.tblpersonid,
          },
          {
            key: 'startdate',
            datevalue: this.targetGegevens.startdate,
          },
          {
            key: 'targetid',
            intvalue: parseInt(this.targetGegevens.tblProfGroupTargetID),
          },
        ],
        graphIDForUrl: graphClickinfo.graphID,
        defaultfilter: '',
        // huub: default filter wel meegeven. nog naar kijken.
      }
      this.getGraphUrl({ graphGetUrlinputApi: graphGetUrlinputApi, graphShowInPopup: graphClickinfo.graphShowInPopup })
    },
    btnTerug: function () {
      if (this.settings.hypBack_NavigateUrl.indexOf('spe020PrStatusoverzicht') !== -1) {
        this.resetData()
        this.$router.push({ name: 'Spe020PrStatusoverzicht' })
      } else {
        window.location = this.settings.hypBack_NavigateUrl
      }
    },
    btnDossierSubmit() {
      window.location = this.targetGegevens.wizardDossierLink
    },
    btnspE060Link() {
      window.location = this.targetGegevens.spE060Link
    },
    spanShowCompChart() {
      if (this.competenceloaded === false) {
        this.getcompetence()
      }
      if (this.competenceloaded === true) {
        this.setpagesettings({
          compchartvisible: true,
        })
      }
    },
    spanHideCompChart() {
      this.setpagesettings({
        compchartvisible: false,
      })
    },
    spanShowCompTable() {
      this.setpagesettings({
        comptablevisible: true,
      })
    },
    spanHideCompTable() {
      this.setpagesettings({
        comptablevisible: false,
      })
    },
    showAllSubrules() {
      this.subrules.forEach((s) => {
        this.getXVtable(s.tblProfGroupSubRuleID)
      })
      this.toggleSubruleVisible(true)
    },
    hideAllSubrules() {
      this.toggleSubruleVisible(false)
    },
    compFilterfunc(tabledata) {
      return tabledata
    },
    printpage() {
      window.print()
    },
  },
}
</script>

<style scoped>
.stickybar {
  padding: 10px 10px 10px 10px;
}
.stickybartext {
  font-size: 16px;
  font-weight: 700;
}
.flex-container {
  border: 1px solid #c7c7c7;
}
.subtarget-mainheader {
  padding: 10px 10px 10px 14px;
  background-color: #ccc;
  color: #000;
  font-weight: 700;
}
@media print {
  .prof_Spe026PrDetailPE .stickybar {
    display: none;
  }
}
</style>
